import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { CheckCircle2, XCircle } from 'lucide-react';

interface AprovacaoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tipo: 'aprovar' | 'rejeitar';
  onConfirm: (justificativa: string) => void;
  isPending: boolean;
}

const AprovacaoDialog = ({ open, onOpenChange, tipo, onConfirm, isPending }: AprovacaoDialogProps) => {
  const [justificativa, setJustificativa] = useState('');

  const handleConfirm = () => {
    onConfirm(justificativa);
    setJustificativa('');
  };

  const isAprovar = tipo === 'aprovar';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {isAprovar ? (
              <>
                <CheckCircle2 className="h-5 w-5 text-green-600" />
                Aprovar Mudança
              </>
            ) : (
              <>
                <XCircle className="h-5 w-5 text-red-600" />
                Rejeitar Mudança
              </>
            )}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="justificativa">
              Justificativa {!isAprovar && '*'}
            </Label>
            <Textarea
              id="justificativa"
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
              placeholder={
                isAprovar
                  ? 'Descreva o motivo da aprovação (opcional)...'
                  : 'Descreva o motivo da rejeição (obrigatório)...'
              }
              rows={4}
              required={!isAprovar}
            />
          </div>

          {!isAprovar && (
            <p className="text-sm text-muted-foreground">
              ⚠️ A mudança será cancelada após a rejeição.
            </p>
          )}
        </div>

        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            Cancelar
          </Button>
          <Button
            variant={isAprovar ? 'default' : 'destructive'}
            onClick={handleConfirm}
            disabled={isPending || (!isAprovar && !justificativa.trim())}
          >
            {isPending ? 'Processando...' : isAprovar ? 'Confirmar Aprovação' : 'Confirmar Rejeição'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AprovacaoDialog;
